module.exports = __webpack_public_path__ + "static/media/ibopad3.b6161c2d.png";